import gql from 'graphql-tag';
import FieldsBooking from "graphql/fields/FieldsBooking";
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsJobtitle from "graphql/fields/FieldsJobtitle";
import HelperGraphql from 'utils/helper-graphql'
import FieldsEmployeeSimple from 'graphql/fields/FieldsEmployeeSimple'
import FieldsTranslation from 'graphql/fields/FieldsTranslation'

const fields = {
	'building_guid': 'String',
	'floor_guid': 'String',
	'room_guid': 'String',
	'table_guid': 'String',
	'kind': 'String',
	'sub_kind': 'String',
	'booking_date': '[String]',
	'status': '[String]',
};

export default gql(`
	query employee_bookings( ${ HelperGraphql.createFields( fields ) } ) {
		employee_bookings( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBooking}
			license_plate
			
			building {
				guid
			}
			
			floor {
				guid
			}
			
			room {
				guid
			}
			
			table {
				guid
			}
			
			booking_invitation {
				guid
				
				employee {
					${FieldsEmployeeSimple}
				}
			}
			
			employee_scan {
				guid
				code
				scanned_in_at
				scanned_in_through
				status
			}
			
			employee_parking_scans {
				guid
				scanned_code
				scanned_at
				scanned_through
				status
			}
			
			timeslot {
				guid
				timeslot_start
				timeslot_end
				kind
				
				timeslot_kind {
					guid
					name
					kind
					sub_kind
					
					translations {
						${FieldsTranslation}
					}
				}
			}
			
			employee {
				${FieldsEmployee}
				kind
				
				department {
					${FieldsDepartment}
				}
				
				jobtitle {
					${FieldsJobtitle}
				}
			}
			
			lunch_options {
				lunch_option {
					guid
				}
			}
		}
	}
`);

